export default __webpack_public_path__ + "static/media/exists-procedure.7ec343cf.svg";